<style lang="scss">
.ex-alert {
  position: fixed !important;
  z-index: 99999;
  bottom: 24px;
  right: 80px;
  font-size: 12px;
  padding: 20px 30px;
  border-radius: 8px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
  &.error {
    background-color: #ff0000;
  }
  &.success {
    background-color: #0da313;
  }
  i {
    margin-right: 10px;
    color: #ffffff !important;
  }
  span {
    font-weight: bold;
    color: #ffffff;
    text-transform: uppercase;
  }
  a {
    font-weight: bold;
    color: #ffffff;
  }
}
</style>
<template>
  <div>
    <div
      v-if="message"
      :style="{ right: `${right}px`}"
      :type="success ? 'success' : 'error'"
      class="ex-alert text-center"
      :class="{ error: error, success: success }"
    >
    <v-icon v-if="error">error</v-icon>
    <v-icon v-if="success">check</v-icon>
    <span>{{message}} </span> <a @click="nextRouter" class="text-decoration-underline pl-3"> {{ $t('HERE') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String
  },
  data() {
    return {
      right: 40
    };
  },
  watch: {
    message(value) {
      if (value)
        setTimeout(() => {
          let data = { message: "" };
          this.$store.commit("alertLink/display", data);
        }, 10000);
    }
  },
  methods: {
    close() {
        let data = { message: "" };
        this.$store.commit("alertLink/display", data);
    },
    nextRouter() {
        this.$router.push({
            name: this.link
        })
        let data = { message: "" };
        this.$store.commit("alertLink/display", data);
    }
  },
  computed: {
    message(value) {
      return this.$store.state.alertLink.message;
    },
    error() {
      return this.$store.state.alertLink.error;
    },
    success() {
      return this.$store.state.alertLink.success;
    },
     res() {
      return this.$store.state.alertLink.res;
    },
    link() {
        return this.$store.state.alertLink.link;
    }
  },
  created() {
    if (window.location.pathname == "/register") {
      this.right = 128;
    }
  }
};
</script>
